<template>
  <SeoHead :seo="seo" />
  <MainLayout>
    <div class="teams-page">
      <PageHeader title="Команды">
        <SeasonSelect
          :model-value="selectedSeasonId"
          :seasons="seasons"
          :multiple="false"
          include-all
          @change="onSeasonChange"
        />
      </PageHeader>

      <div v-if="teams.length" class="teams-poster-grid">
        <Link
          v-for="team in teams"
          :key="team.id"
          :href="team.url"
          class="team-poster"
        >
          <div
            class="team-poster__media"
            :class="{ 'team-poster__media--empty': !team.image_url }"
            :style="team.image_url ? { backgroundImage: `url(${team.image_url})` } : undefined"
          >
            <span v-if="!team.image_url" class="team-poster__placeholder">
              {{ team.short_name }}
            </span>
            <div class="team-poster__shade" />
            <div class="team-poster__meta">
              <div class="team-poster__identity">
                <div class="team-poster__logo" :class="{ 'team-poster__logo--empty': !team.logo_url }">
                  <img
                    v-if="team.logo_url"
                    :src="team.logo_url"
                    :alt="team.name"
                    class="team-poster__logo-img"
                  />
                  <span v-else class="team-poster__logo-fallback">
                    {{ logoInitials(team.short_name) }}
                  </span>
                </div>
                <div class="team-poster__text">
                  <h2 class="team-poster__name">{{ team.name }}</h2>
                  <p v-if="team.city" class="team-poster__city">{{ team.city }}</p>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div v-else class="teams-empty">
        {{ isAllSeasons ? 'Нет команд' : 'Нет команд в этом сезоне' }}
      </div>
    </div>
  </MainLayout>
</template>

<script setup>
import { computed } from 'vue';
import { Link, router } from '@inertiajs/vue3';
import SeoHead from '@/Components/SeoHead.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';
import SeasonSelect from '@/components/filters/SeasonSelect.vue';

const props = defineProps({
  seo: {
    type: Object,
    default: null,
  },
  teams: {
    type: Array,
    required: true,
  },
  seasons: {
    type: Array,
    default: () => [],
  },
  currentSeasonId: {
    type: [Number, String],
    default: null,
  },
});

const selectedSeasonId = computed(() => props.currentSeasonId);
const isAllSeasons = computed(() => props.currentSeasonId === 'all');

function onSeasonChange(seasonId) {
  if (seasonId === null || seasonId === undefined || seasonId === '') {
    return;
  }

  router.get(
    '/teams',
    { season_id: seasonId },
    {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    },
  );
}

function logoInitials(shortName) {
  if (!shortName) {
    return '?';
  }

  return String(shortName).slice(0, 2).toUpperCase();
}
</script>
